import { TuiTooltip } from '@taiga-ui/kit';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  TuiIcon,
  TuiHint,
  TuiInput,
  TuiTextfield,
  TuiLabel,
} from '@taiga-ui/core';
import { WorkflowFormFieldInputString } from '@features/requests/request-form/components/request-form-workflows/types';

@Component({
  selector: 'x-input-string-field',
  imports: [
    TuiTextfield,
    TuiLabel,
    ReactiveFormsModule,
    TuiInput,
    TuiHint,
    TuiIcon,
    TuiTooltip,
  ],
  templateUrl: './input-string-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class InputStringFieldComponent {
  field = input.required<WorkflowFormFieldInputString>();
  control = input.required<FormControl<string | null>>();
}
